import React from "react";

const Footer = () => {
  return (
    <>
      <div className="o-appointment__box-and-letter">
        <div className="o-appointment__box"></div>
        <div className="o-appointment__letter">Días disponibles</div>
      </div>
      <p className="o-appointment__footer">
        Todas las horas corresponden a la zona horaria (UTC-05:00) Bogotá, Lima,
        Quito.
      </p>
    </>
  );
};

export default Footer;
